/**
 * Module "Deal" — <deal-card-badge> sur les cartes produit.
 * Un seul setInterval partagé pour toutes les cartes de la page (perf sur grilles de 48+ produits).
 * Compatible filtres / pagination AJAX de Dawn : les nouveaux éléments s'enregistrent via connectedCallback.
 */
(() => {
  if (customElements.get('deal-card-badge')) return;

  const instances = new Set();
  let timer = null;
  const pad = (n) => String(n).padStart(2, '0');

  const tickAll = () => {
    const now = Date.now();
    instances.forEach((el) => el.tick(now));
    if (!instances.size) {
      clearInterval(timer);
      timer = null;
    }
  };

  class DealCardBadge extends HTMLElement {
    connectedCallback() {
      this.endMs = parseInt(this.dataset.end, 10) * 1000;
      this.dayLabel = this.dataset.dayLabel || 'j';
      this.output = this.querySelector('[data-role="countdown"]');
      if (!this.endMs || !this.output) return;

      instances.add(this);
      this.tick(Date.now());
      if (!timer) timer = setInterval(tickAll, 1000);
    }

    disconnectedCallback() {
      instances.delete(this);
    }

    tick(now) {
      const diff = this.endMs - now;
      if (diff <= 0) {
        instances.delete(this);
        this.remove();
        return;
      }
      const t = Math.floor(diff / 1000);
      const d = Math.floor(t / 86400);
      const h = Math.floor((t % 86400) / 3600);
      const m = Math.floor((t % 3600) / 60);
      const s = t % 60;
      const text = `${d > 0 ? `${d}${this.dayLabel} ` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
      if (this.output.textContent !== text) this.output.textContent = text;
    }
  }

  customElements.define('deal-card-badge', DealCardBadge);
})();